import * as DFns from "date-fns";

export const handleFullNameSort = (a, b) =>
  `${a.firstName}${a.lastName}` > `${b.firstName}${b.lastName}` ? 1 : -1;

export const handleNameSort = (a, b) => (a.name > b.name ? 1 : -1);

export const handleCreatedAtSortDesc = (a, b) =>
  a.createdAt > b.createdAt ? -1 : 1;

export const handleCreatedAtSortAsc = (a, b) =>
  a.createdAt > b.createdAt ? 1 : -1;

export const getSpecialistReducer =
  (regionsOptions) =>
  (
    acc,
    { id, firstName, lastName, email, phone, marketingRegionId },
    index
  ) => ({
    ...acc,
    [id]: {
      label:
        `${firstName} ${lastName}, ${!!phone ? phone : email}` +
        // `${firstName} ${lastName}, ${email}, ${phone}` +
        (marketingRegionId && regionsOptions[marketingRegionId]
          ? `, ${regionsOptions[marketingRegionId]}`
          : ""),
      selected: false,
    },
  });

export const dateToUsFormat = (mysqlDate) => {
  if (!mysqlDate) return;

  const date = new Date(mysqlDate);
  const result = new Intl.DateTimeFormat("en-US", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);

  return result;
};

export const dateToUsShortFormat = (mysqlDate) => {
  if (!mysqlDate) return;

  const date = new Date(mysqlDate);
  const result = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(date);

  return result;
};

export const dateToUsBirthFormat = (mysqlDate) => {
  if (!mysqlDate) return;

  const date = new Date(mysqlDate);
  const result = new Intl.DateTimeFormat("en-US", {
    dateStyle: "short",
  }).format(date);

  return result;
};

export const dateToUsShortFormatWithoutYear = (mysqlDate) => {
  if (!mysqlDate) return;

  const date = new Date(mysqlDate);
  const result = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(date);

  return result.split(",")[0];
};

export const USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const convertDeviceType = (deviceType) => {
  if (deviceType === "Virtual") {
    return "Digital";
  }
  if (deviceType === "Real") {
    return "Physical";
  }
  return deviceType;
};

export const getHandleSearchFilter = (search) => (row) => {
  if (!search) return true;

  const keys = Object.keys(row);

  return keys.some((key) =>
    String(row[key]).toLowerCase().includes(search.toLowerCase())
  );
};

export const removeTimezoneOffset = (currentDate) => {
  try {
    const parsedStartDate = new Date(currentDate);
    const utcOffset = -parsedStartDate.getTimezoneOffset();
    const endDate = DFns.addMinutes(parsedStartDate, utcOffset);

    return endDate?.toISOString().slice(0, 19).replace("T", " ");
  } catch (e) {
    return "";
  }
};

export const updateRoleSelection = (
  selectedSpecialists,
  role,
  list,
  setList
) => {
  const selected = selectedSpecialists
    .filter((row) => row?.role === role)
    .map(({ specialistId }) => specialistId);

  const updatedList = JSON.parse(JSON.stringify(list));
  selected.forEach((id) => {
    updatedList[id].selected = true;
  });

  setList(updatedList);
};

export const getWeekStartAndEndDates = (week, year) => {
  const firstDayOfYear = new Date(year, 0, 1);
  const daysOffset = week * 7;
  const startDate = new Date(
    firstDayOfYear.setDate(firstDayOfYear.getDate() + daysOffset)
  );
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  return {
    start: formatDate(startDate),
    end: formatDate(endDate),
  };
};

export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export const displayDobTime = (dateTime) => {
  if (!dateTime) {
    return null;
  }

  const date = new Date(dateTime);
  const month = (date.getUTCMonth() + 1).toString(); // Months are zero-based
  const day = date.getUTCDate().toString();
  const year = date.getUTCFullYear();
  const result = `${month}/${day}/${year}`;

  return result;
};

export const displayLocalDateTime = (dateTime) => {
  if (!dateTime) {
    return null;
  }
  const localDateTime = `${dateTime?.slice(0, 19).split(" ").join("T")}.000Z`;
  const date = new Date(localDateTime);
  return new Intl.DateTimeFormat("en-US", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
};

export const displayCreatedAt = ({ createdAt }) => {
  return displayLocalDateTime(createdAt);
};

export const displayInvoiceDate = ({ invoice_date }) => {
  return displayLocalDateTime(invoice_date);
};

export const compareArrays = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  return (
    arr1.every((item) => arr2.includes(item)) &&
    arr2.every((item) => arr1.includes(item))
  );
};

export const trimAllStringValuesInObject = (obj) =>
  Object.keys(obj).reduce((acc, key) => {
    acc[key] = typeof obj[key] === "string" ? obj[key].trim() : obj[key];
    return acc;
  }, {});
